import { GripVertical, Trash2, ExternalLink } from 'lucide-react';
import { PlatformIcon } from '@/components/ui';
import { getPlatformName } from '@/utils/platformDetector';
import type { LinkPageLink } from '@/types';

interface LinkPageLinkItemProps {
  link: LinkPageLink;
  onRemove: (linkId: string) => void;
}

const LinkPageLinkItem = ({ link, onRemove }: LinkPageLinkItemProps) => {
  const deeplinkUrl = `https://klipr.it/${link.deeplinkCode}`;

  return (
    <div className="flex items-center gap-3 p-3 bg-white dark:bg-dark-800 border border-gray-100 dark:border-dark-700 rounded-xl group hover:shadow-sm transition-shadow">
      {/* Drag handle */}
      <div className="flex-shrink-0 cursor-grab text-gray-300 dark:text-gray-600 hover:text-gray-500">
        <GripVertical className="w-5 h-5" />
      </div>

      {/* Platform icon */}
      <div className="flex-shrink-0">
        <PlatformIcon platform={link.platform} size="sm" />
      </div>

      {/* Content */}
      <div className="flex-1 min-w-0">
        <p className="text-sm font-medium text-dark-800 dark:text-white truncate">
          {link.title || getPlatformName(link.platform)}
        </p>
        <p className="text-xs text-gray-400 truncate">
          {link.originalUrl}
        </p>
      </div>

      {/* Music match group indicator */}
      {link.musicMatchGroup && (
        <span className="flex-shrink-0 text-xs px-2 py-0.5 rounded-full bg-purple-100 text-purple-600 dark:bg-purple-900/30 dark:text-purple-400">
          music
        </span>
      )}

      {/* Actions */}
      <div className="flex items-center gap-1 flex-shrink-0 opacity-0 group-hover:opacity-100 transition-opacity">
        <a
          href={deeplinkUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="p-1.5 text-gray-400 hover:text-lime-600 transition-colors rounded-lg"
        >
          <ExternalLink className="w-3.5 h-3.5" />
        </a>
        <button
          onClick={() => onRemove(link.id)}
          className="p-1.5 text-gray-400 hover:text-red-500 transition-colors rounded-lg"
        >
          <Trash2 className="w-3.5 h-3.5" />
        </button>
      </div>
    </div>
  );
};

export default LinkPageLinkItem;
